/**
 * `promise`, or `fallback` once `ms` pass without an answer. The promise is not cancelled:
 * whatever it was doing finishes behind, which is the point for a request that must not be
 * aborted once the server may have acted on it (#643, `boot.ts`).
 */
export function within<T, F>(promise: Promise<T>, ms: number, fallback: F): Promise<T | F> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const late = new Promise<F>((resolve) => {
    timer = setTimeout(() => resolve(fallback), ms);
  });
  return Promise.race([promise, late]).finally(() => clearTimeout(timer));
}
